import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiArrowRight } from 'react-icons/fi';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">העמוד לא נמצא</h2>
        <p className="not-found-text">
          מצטערים, העמוד שחיפשת אינו קיים או שהוסר.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-btn-primary">
            <FiHome />
            חזרה לעמוד הבית
          </Link>
          <Link to="/campaigns" className="not-found-btn-secondary">
            צפה בקמפיינים
            <FiArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
